<div
  class="visitor-card-container"
  tabindex="0"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
>
  <div class="img-card">
    <img
      [src]="user.imgUrl | versionedImageUrl : user.profileImageUpdatedAt"
      [alt]="user.userName"
      loading="lazy"
    />
    <div class="title-img">
      <h1>{{ user.userName }}</h1>
      @if (userCity) {
      <p>
        <img class="icon-visitors" src="assets/icons/location.svg" alt="icons visitors" />{{
          userCity
        }}
      </p>
      } @if (user.age !== null && user.age !== undefined) {
      <p>
        <img class="icon-visitors" src="assets/icons/visitors.svg" alt="icons visitors" />{{
          user.age
        }}
        ans
      </p>
      }
    </div>
  </div>
</div>
